import React, { useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';

interface GuestAllowedProps {
  children: React.ReactNode;
}

export const GuestAllowed: React.FC<GuestAllowedProps> = ({ children }) => {
  const { isLoggedIn, isAuthLoading, setGuestMode } = useAuth();

  useEffect(() => {
    if (isAuthLoading) {
      return;
    }

    // If user is not logged in, enable guest mode
    if (!isLoggedIn) {
      setGuestMode(true);
    } else {
      setGuestMode(false);
    }

    // Cleanup on unmount
    return () => {
      setGuestMode(false);
    };
  }, [isAuthLoading, isLoggedIn, setGuestMode]);

  return <>{children}</>;
};
